// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/right-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

body {
    height: 100vh;
}

button:hover {
    cursor: pointer;
}

.frame {
    height: 360px;
    width: 360px;
    position: relative;
    overflow: hidden;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
}

.slides-wrapper {
    width: max-content;
    transform: translateX(-0%);
    display: flex;
}

.slide {
    height: 360px;
    width: 360px;
    text-align: center;
}

.slide-image {
    display: inline-block;
    height: 360px;
}

.carousel-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 24px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-color: transparent;
    border: 0;
    transition: 0.3s;
}

.carousel-button.left {
    left: 0;
    transform: translateY(-50%) scaleX(-1);
}

.carousel-button.left:hover {
    transform: translateY(-50%) scaleX(-1) scale(1.2);
}

.carousel-button.right {
    right: 0;
}

.carousel-button.right:hover {
    transform: translateY(-50%) scale(1.2);
}

.carousel-dot-wrapper {
    height: 36px;
    width: fit-content;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
}

.carousel-dot {
    height: 8px;
    width: 8px;
    border: 1px solid white;
    border-radius: 50%;
    transition: 0.3s;
}

.carousel-dot.selected {
    background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,yDAAiD;IACjD,wBAAwB;IACxB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,sCAAsC;AAC1C;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n}\n\nbody {\n    height: 100vh;\n}\n\nbutton:hover {\n    cursor: pointer;\n}\n\n.frame {\n    height: 360px;\n    width: 360px;\n    position: relative;\n    overflow: hidden;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 8px;\n}\n\n.slides-wrapper {\n    width: max-content;\n    transform: translateX(-0%);\n    display: flex;\n}\n\n.slide {\n    height: 360px;\n    width: 360px;\n    text-align: center;\n}\n\n.slide-image {\n    display: inline-block;\n    height: 360px;\n}\n\n.carousel-button {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 24px;\n    width: 24px;\n    background-image: url(\"./assets/right-arrow.svg\");\n    background-size: contain;\n    background-color: transparent;\n    border: 0;\n    transition: 0.3s;\n}\n\n.carousel-button.left {\n    left: 0;\n    transform: translateY(-50%) scaleX(-1);\n}\n\n.carousel-button.left:hover {\n    transform: translateY(-50%) scaleX(-1) scale(1.2);\n}\n\n.carousel-button.right {\n    right: 0;\n}\n\n.carousel-button.right:hover {\n    transform: translateY(-50%) scale(1.2);\n}\n\n.carousel-dot-wrapper {\n    height: 36px;\n    width: fit-content;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.carousel-dot {\n    height: 8px;\n    width: 8px;\n    border: 1px solid white;\n    border-radius: 50%;\n    transition: 0.3s;\n}\n\n.carousel-dot.selected {\n    background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
